import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import UnifiedInvestmentTools from './components/UnifiedInvestmentTools';
import ReportSelector from './components/ReportSelector';
import ContentBody from './components/ContentBody';
import ExpertAnswers from './components/ExpertAnswers';
import ContactQA from './components/ContactQA';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import SchemaInjector from './components/SchemaInjector';
import ReviewPage from './components/ReviewPage';
import BestCompaniesPage from './components/BestCompaniesPage';
import PortfolioComparisonPage from './components/PortfolioComparisonPage';

// Scroll to top component for route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const HomePage = () => (
  <main className="flex-grow">
    <Hero />
    <UnifiedInvestmentTools />
    <ReportSelector />
    <ContentBody />
    <ExpertAnswers />
    <ContactQA />
    <FAQ />
  </main>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col font-sans">
        <ScrollToTop />
        <SchemaInjector />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/gold-ira-review" element={<ReviewPage />} />
          <Route path="/best-gold-ira-companies" element={<BestCompaniesPage />} />
          <Route path="/portfolio-comparison" element={<PortfolioComparisonPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;